/*
 * ahax
 * @Author: fan.li@zuolin.com
 * @Date: 2019-08-05 15:13:31
 * @Last Modified by: fan.lion@foxmail.com
 * @Last Modified time: 2020-02-17 18:09:54
 */

// 设置面包屑上的管理按钮
const SETBUTTON = 'SETBUTTON';
// 设置面包屑上的帮助按钮
const HELPBUTTON = 'HELPBUTTON';
// 上下文切换
const SCOPECHANGE = 'SCOPECHANGE';
// 项目导航专用的事件
const FUCNTIONHEADERCHANGE = 'FUNCTIONHEADERCHANGE';
// 更新 ProjectTree
const UPDATEPROJECTTREE = 'UPDATEPROJECTTREE';
// 更新菜单
const UPDATEMENU = 'UPDATEMENU';
const TEST = 'TEST';

export { SETBUTTON, HELPBUTTON, SCOPECHANGE, FUCNTIONHEADERCHANGE, UPDATEPROJECTTREE, UPDATEMENU, TEST };
